import { Flex, Text, rotatePhone, Icon } from '../../2022-component-library';
import { keyframes } from '@emotion/react';

const rotationAnimation = keyframes`
0% {
    transform: rotate(180deg);
}

30% {
    transform: rotate(90deg);
}

70%{
    transform: rotate(90deg);
}

100% {
    transform: rotate(180deg);
}`;

const ResponsiveRotateScreen = ({ orientation }) => {
  return (
    <Flex column centered padding='2rem'>
      <Text textAlign='center' marginBottom='5rem'>{`Please rotate your screen to "${orientation}" mode to continue.`}</Text>
      <Icon icon={rotatePhone} animation={`${rotationAnimation} 5s ease infinite`} />
    </Flex>
  );
};

export default ResponsiveRotateScreen;
